import React from 'react'
import { Button } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import BackButtonArrow from '../assets/back-button-arrow'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '../../utils/themeContext'
import { getColorsForTheme } from '../../global-styles/clientColors'

const useStyles = makeStyles()(() => {
  return {
    backButton: {
      border: 'none',
      marginTop: 80,
      marginBottom: 25,
      '&:hover': {
        border: 'none',
      },
      '& .MuiButton-startIcon': {
        marginBottom: 5,
      },
    },
  }
})

type BackButtonProps = {
  lastPageRoute?: string
}

export const BackButton = ({ lastPageRoute }: BackButtonProps) => {
  const { currentTheme } = useTheme()
  const themeColors = getColorsForTheme(currentTheme)
  const { classes } = useStyles()
  const navigate = useNavigate()

  return (
    <Button
      className={classes.backButton}
      onClick={lastPageRoute ? () => navigate(`${lastPageRoute}`) : () => navigate(-1)}
      variant="outlined"
      startIcon={<BackButtonArrow />}
      sx={{
        color: themeColors.buttonColor,
        borderColor: themeColors.buttonColor,
        '&:hover': {
          borderColor: themeColors.buttonHover,
          color: themeColors.buttonHover,
        },
      }}
    >
      Back
    </Button>
  )
}
